import { State } from 'country-state-city'
import { useState, useEffect, useRef } from 'react'
import Select from 'react-select'

const StateProvinceSelect = ({ countryCode, handleChangeState, stateValue, placeholder }) => {
  const [statesOfCountry, setStatesOfCountry] = useState([])
  const [selectedState, setSelectedState] = useState({
    label: stateValue,
    value: stateValue,
    field: 'state'
  })
  const isUserSelection = useRef(false)

  useEffect(() => {
    if (isUserSelection.current) {
      handleChangeState(selectedState)
      isUserSelection.current = false
    }
  }, [selectedState])

  useEffect(() => {
    setStatesOfCountry(State.getStatesOfCountry(countryCode))
  }, [countryCode])

  useEffect(() => {
    if (stateValue !== selectedState.value) {
      const states = State.getStatesOfCountry(countryCode)
      const matchingState = states.find(s => s.isoCode === stateValue || s.name === stateValue)
      setSelectedState({
        label: matchingState?.name || stateValue,
        value: matchingState?.isoCode || stateValue,
        field: 'state'
      })
    }
  }, [stateValue, countryCode])

  const statesOptions = statesOfCountry.map(state => {
    return {
      label: state.name,
      value: state.isoCode,
      field: 'state'
    }
  })

  const handleUserSelect = newState => {
    isUserSelection.current = true
    setSelectedState(newState)
  }

  return (
    <Select
      name="state"
      value={selectedState}
      isClearable={false}
      options={statesOptions}
      onChange={handleUserSelect}
      placeholder={placeholder ? placeholder : 'Select...'}
    />
  )
}

export default StateProvinceSelect
